// extracted by mini-css-extract-plugin
export default {"button_group":"Posts_button_group__r4K7+","modal_add_post":"Posts_modal_add_post__04m9f","update_posts":"Posts_update_posts__DZx6a","pagination":"Posts_pagination__7-fwd"};